import {Component, OnDestroy, OnInit} from '@angular/core';
import {PayingPageBase} from '../../general/PayingPageBase';
import {AppService} from '../../../services/app.service';

@Component({
	selector: 'app-tur-paying',
	templateUrl: './tur-paying.component.html',
	styleUrls: ['./tur-paying.component.scss']
})
export class TurPayingComponent extends PayingPageBase implements OnInit, OnDestroy {

	theme: string = "tur";

	constructor(app: AppService) {
		super(app);
	}
}
